import { render } from "./newFooter.vue?vue&type=template&id=d63d6ed0&scoped=true&ts=true"
import script from "./newFooter.vue?vue&type=script&lang=ts"
export * from "./newFooter.vue?vue&type=script&lang=ts"

import "./newFooter.vue?vue&type=style&index=0&id=d63d6ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63d6ed0"]])

export default __exports__